import React, { useEffect, useState, useContext } from 'react';
import axios from '../api/axiosConfig';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import NuevoTramiteModal from '../components/NuevoTramiteModal';
import DetalleTramiteModal from '../components/DetalleTramiteModal';
import EditarTramiteModal from '../components/EditarTramiteModal';
import { AuthContext } from '../context/AuthContext';
import TramiteDeleteModal from '../components/TramiteDeleteModal';
import Pagination from '../components/Pagination';
import NovedadesTramiteModal from '../components/NovedadesTramiteModal';
import './Profiles.css'; // Reutilizamos estilos base

const MisTramites = () => {
  const { user } = useContext(AuthContext);
  const [tramites, setTramites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Estado para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  // Estado para el modal de detalle
  const [selectedTramiteId, setSelectedTramiteId] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  // Estado para el modal de edición
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedTramiteForEdit, setSelectedTramiteForEdit] = useState(null);


  // Estado para eliminación de trámites
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedTramiteToDelete, setSelectedTramiteToDelete] = useState(null);

  // Estado para el modal de novedades
  const [isNovedadesModalOpen, setIsNovedadesModalOpen] = useState(false);
  const [novedadesTramiteId, setNovedadesTramiteId] = useState(null);

  useEffect(() => {
    fetchTramites();
  }, []);

  const fetchTramites = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/tramites');
      setTramites(res.data);
      setError('');
    } catch (err) {
      setError('Error al cargar tus trámites');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statuses = {
      'radicado': { label: '📝 Radicado', class: 'pending' },
      'pre_asignado': { label: '🚗 Pre-Asignado', class: 'activo' },
      'novedad_pendiente_soat': { label: '⚠️ SOAT Pendiente', class: 'warning' },
      'novedad_soat_cargado': { label: '📄 SOAT Cargado', class: 'warning' },
      'novedad_soat_vigente': { label: '✅ SOAT Vigente', class: 'paid' },
      'novedad_pendiente_cupl': { label: '⚠️ CUPL Pendiente', class: 'warning' },
      'novedad_cupl_generado': { label: '📄 CUPL Generado', class: 'warning' },
      'novedad_cupl_pagado': { label: '💳 CUPL Pagado', class: 'paid' },
      'tramite_ejecutado': { label: '🔒 Ejecutado', class: 'paid' },
      'rechazado': { label: '❌ Rechazado', class: 'expired' }
    };
    const s = statuses[status] || { label: status, class: '' };
    return <span className={`status ${s.class}`}>{s.label}</span>;
  };



  const openDetalle = (id) => {
    setSelectedTramiteId(id);
    setIsDetailModalOpen(true);
  };

  const openEdit = (id) => {
    setSelectedTramiteForEdit(id);
    setIsEditModalOpen(true);
  };

  const openDeleteConfirm = (tramite) => {
    setSelectedTramiteToDelete(tramite);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedTramiteToDelete) return;
    try {
      await axios.delete(`/api/tramites/${selectedTramiteToDelete.id}`);
      setIsDeleteModalOpen(false);
      setSelectedTramiteToDelete(null);
      fetchTramites();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al eliminar el trámite');
    }
  };

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = tramites.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Navbar title="📁 Mis Trámites" />

        <div className="page-content">
          {error && <div className="error-banner">{error}</div>}

          <div className="page-header">
            <div className="header-title">
              <h2>Listado de Solicitudes</h2>
              <p className="subtitle">Seguimiento en tiempo real de tus trámites iniciados</p>
            </div>
            <button onClick={() => setIsModalOpen(true)} className="btn-primary">
              ➕ Nuevo Trámite
            </button>
          </div>

          {loading ? (
            <p className="loading">Cargando trámites...</p>
          ) : (
            <div className="table-wrapper">
              <table className="users-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Tipo de Trámite</th>
                    <th>Tránsito</th>
                    <th>Propietario</th>
                    <th>Placa</th>
                    <th>Estado</th>
                    <th>Fecha</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map(t => (
                    <tr key={t.id}>
                      <td><strong>#{t.id}</strong></td>
                      <td>{t.tramite_type_name}</td>
                      <td>{t.transito_name}</td>
                      <td>{t.datos_adicionales?.propietario || 'N/A'}</td>
                      <td>
                        {t.datos_adicionales?.placa_referencia ? (
                          <span className="plate-badge-sm">{t.datos_adicionales.placa_referencia}</span>
                        ) : '—'}
                      </td>
                      <td>{getStatusBadge(t.estado)}</td>
                      <td>{new Date(t.created_at).toLocaleDateString()}</td>
                      <td className="actions">
                        <button 
                          className="btn-action btn-view" 
                          onClick={() => openDetalle(t.id)}
                        >
                          👁️ Ver Detalle
                        </button>
                        {t.pending_novelties_count > 0 ? (
                          <button 
                            className="btn-action btn-warning" 
                            onClick={() => {
                              setNovedadesTramiteId(t.id);
                              setIsNovedadesModalOpen(true);
                            }} 
                            title={`Este trámite tiene ${t.pending_novelties_count} novedades pendientes`}
                            style={{
                              background: 'rgba(245, 158, 11, 0.1)',
                              color: '#d97706',
                              border: '1px solid rgba(245, 158, 11, 0.2)',
                              padding: '6px 10px',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              marginLeft: '5px',
                              transition: 'all 0.25s'
                            }}
                          >
                            ⚠️ Novedad ({t.pending_novelties_count})
                          </button>
                        ) : (
                          <button 
                            className="btn-action" 
                            onClick={() => {
                              setNovedadesTramiteId(t.id);
                              setIsNovedadesModalOpen(true);
                            }} 
                            style={{ 
                              background: 'rgba(71, 85, 105, 0.1)', 
                              color: '#475569', 
                              border: '1px solid rgba(71, 85, 105, 0.2)', 
                              padding: '6px 10px',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              marginLeft: '5px',
                              transition: 'all 0.25s'
                            }}
                          >
                            📋 Novedades
                          </button>
                        )}
                        <button 
                          className="btn-action btn-edit" 
                          onClick={() => openEdit(t.id)}
                          disabled={['novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado'].includes(t.estado)}
                          title={['novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado'].includes(t.estado) ? "No se puede editar: SOAT ya validado y activo" : "Editar Trámite"}
                          style={{
                            background: ['novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado'].includes(t.estado) ? 'rgba(241, 245, 249, 0.5)' : 'rgba(37, 99, 235, 0.1)',
                            color: ['novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado'].includes(t.estado) ? '#94a3b8' : '#2563eb',
                            border: ['novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado'].includes(t.estado) ? '1px solid #e2e8f0' : '1px solid rgba(37, 99, 235, 0.2)',
                            padding: '6px 10px',
                            borderRadius: '6px',
                            cursor: ['novedad_soat_vigente', 'novedad_pendiente_cupl', 'novedad_cupl_generado', 'novedad_cupl_pagado', 'tramite_ejecutado'].includes(t.estado) ? 'not-allowed' : 'pointer',
                            marginLeft: '5px',
                            transition: 'all 0.2s'
                          }}
                        >
                          ✏️ Editar
                        </button>
                        {user?.role === 'superadmin' && (
                          <button 
                            className="btn-action" 
                            onClick={() => openDeleteConfirm(t)}
                            style={{ 
                              background: 'rgba(239, 68, 68, 0.1)', 
                              color: '#ef4444', 
                              border: '1px solid rgba(239, 68, 68, 0.2)',
                              padding: '6px 10px',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              marginLeft: '5px',
                              transition: 'all 0.2s'
                            }}
                            title="Eliminar Trámite"
                          >
                            🗑️
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {tramites.length === 0 && (
                <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                  Aún no has iniciado ningún trámite.
                </div>
              )}

              <Pagination 
                currentPage={currentPage}
                totalItems={tramites.length}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </div>
          )}
        </div>
      </div>

      <NuevoTramiteModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSuccess={fetchTramites} 
      />

      <DetalleTramiteModal
        isOpen={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        tramiteId={selectedTramiteId}
        onUpdate={fetchTramites}
      />

      <NovedadesTramiteModal 
        isOpen={isNovedadesModalOpen}
        onClose={() => {
          setIsNovedadesModalOpen(false);
          setNovedadesTramiteId(null);
        }}
        tramiteId={novedadesTramiteId}
        onSuccess={fetchTramites}
        readOnly={true}
      />

      <EditarTramiteModal
        isOpen={isEditModalOpen}
        tramiteId={selectedTramiteForEdit}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedTramiteForEdit(null);
        }}
        onSuccess={fetchTramites}
      />


      <TramiteDeleteModal
        isOpen={isDeleteModalOpen}
        tramite={selectedTramiteToDelete}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
      />
    </div>
  );
};

export default MisTramites;
